import React, { useState, useEffect, useMemo } from 'react';
import { getdata, TIMEDATA, DAILYAVAILABLETIME, CLOSEDDATA, formatdate, getdate,updatedata, sendwhatsappmessage, WAITINGGIF} from "../../util/global";
import { load } from "@cashfreepayments/cashfree-js";


const PaymentForm = ({ showmodal, setshowmodal, formdata, setformdata, phonenumberdata, paymentdata }) => {

  if (showmodal != "showpaymentform" ) return null;

  useEffect(() => { 
    
    setformdata({inr:10,messagecredit:5, phonenumber:phonenumberdata[phonenumberdata.length-1]?.phonenumber});
    if (paymentdata.length > 0) {
      setformdata({...paymentdata[0]});
    }
 
  }, [showmodal]);


  const startpaymentprocess = async () => {
    $("#waitinggif").show();
    let payload =[{ datatype:"paymentdata", ...formdata}];
    console.log(payload);
    let response = await updatedata({dataset:payload}, "/startpaymentprocess");
    console.log(response);
    let paymentsessionid =  response.orderdata[0].payment_session_id;
    processpayment(paymentsessionid);
    //setshowmodal("");
  };

  const processpayment = async (paymentsessionid) => {
    const cashfree = await load({
      mode: "production",
    });
    console.log("cashfree initilized");
    let checkoutoptions = {
      paymentSessionId: paymentsessionid,
      redirectTarget: "_self",
    };
    cashfree.checkout(checkoutoptions);
  };

  const getmessagecredit = (inr) => {
    inr = parseInt(inr.replace(/[^0-9]+/gi, ""));
    return Math.round(inr/2);
  };


  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3></h3>
          <button className="close-btn" onClick={() => setshowmodal(false)}>&times;</button>
        </div>
        <div className="modal-body">
          
          <table>
            <tr>
              <td>
                <div className="form-group">
                  <label>Enter amount in INR</label>
                  <input 
                    type="text" 
                    className="form-input" 
                    value={formdata.inr} 
                    onChange={(e: { target: { value: any; }; }) => setformdata({...formdata, inr: e.target.value.replace(/[^0-9]+/gi, ""), messagecredit:getmessagecredit(e.target.value)})} 
                  />              
                </div>
                <div className="form-group">
                <label>Billing Phone Number</label>
                  <input 
                    type="text" 
                    className="form-input" 
                    value={formdata.phonenumber} 
                    onChange={(e: { target: { value: any; }; }) => { 
                                  setformdata({...formdata, phonenumber: e.target.value.replace(/[^0-9]+/gi, "")});
                                }
                              }
                  />              
                </div>
                <div className="form-group">
                  <label>Number of Messages</label>
                  <input 
                    readOnly
                    type="text" 
                    className="form-input" 
                    value={formdata.messagecredit}  
                  />              
                </div>
              </td>
            </tr> 
          </table>        
          <button className="btn-blue full-width " onClick={() => {startpaymentprocess();}}>
            {formdata._id ? "Proceed" : "Proceed"} <img id="waitinggif" src="/css/whatsappapi/waiting.gif" style={{display:'none', width:'25px',position:'absolute'}}/>
          </button>

          <table class="grid">
            <tr><th>date</th><th>inr</th><th>message credit</th><th>status</th></tr>
            {}
          </table>

        </div>
      </div>
    </div>
  );
};

export default PaymentForm;
